import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table" }

import "components/common/table.css";
import themes from "data/themes";
import settings from "game/settings";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const mergeAdjacent = computed(() => themes[settings.theme].mergeAdjacent);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["row", { mergeAdjacent: _unref(mergeAdjacent) }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})